var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{attrs:{"placement":_vm.placement,"overlayClassName":_vm.overlayClassName}},[_c('template',{slot:"title"},[_vm._t("tooltipTitle",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_vm._t("tooltipBody",function(){return [_c('span',[_vm._v(_vm._s(_vm.body))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }